module.exports = __webpack_public_path__ + "static/pub-sub-bg.fc9e147d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/pub-sub-bg.png
// module id = 813
// module chunks = 35783957827783